import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";

const LINKS = [
  { to: "/", label: "Início", testId: "nav-link-home" },
  { to: "/sobre", label: "Sobre", testId: "nav-link-about" },
  { to: "/servicos", label: "Serviços", testId: "nav-link-services" },
  { to: "/tecnologias", label: "Tecnologias", testId: "nav-link-technologies" },
  { to: "/projetos", label: "Projetos", testId: "nav-link-projects" },
  { to: "/contato", label: "Contato", testId: "nav-link-contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-white/85 backdrop-blur-md border-b border-line">
      <div className="container-x flex items-center justify-between h-16 lg:h-[72px]">
        <Link to="/" aria-label="IPRS Soluções em TI - Página inicial" onClick={() => setOpen(false)}>
          <Logo testId="nav-logo" />
        </Link>

        <nav className="hidden lg:flex items-center gap-1" aria-label="Navegação principal">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              className={({ isActive }) =>
                `px-3.5 py-2 text-sm font-medium transition-colors duration-200 rounded-md ${
                  isActive || (l.to === "/" && pathname === "/")
                    ? "text-techblue"
                    : "text-graphite hover:text-techblue"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link
            to="/contato"
            data-testid="nav-cta-assessment"
            className="inline-flex items-center gap-1.5 bg-techblue hover:bg-techblue-hover text-white text-sm font-semibold px-5 py-2.5 rounded-md transition-colors duration-200"
          >
            Avaliação técnica
            <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <button
          type="button"
          data-testid="nav-mobile-toggle"
          aria-label={open ? "Fechar menu" : "Abrir menu"}
          aria-expanded={open}
          className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-md border border-line text-graphite"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.25, ease: "easeOut" }}
            className="lg:hidden overflow-hidden bg-white border-b border-line"
          >
            <nav className="container-x py-4 flex flex-col" aria-label="Navegação móvel">
              {LINKS.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  data-testid={l.testId}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `py-3 text-base font-medium border-b border-line/70 ${isActive ? "text-techblue" : "text-graphite"}`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
              <Link
                to="/contato"
                data-testid="nav-mobile-cta"
                onClick={() => setOpen(false)}
                className="mt-4 mb-2 inline-flex items-center justify-center gap-1.5 bg-techblue hover:bg-techblue-hover text-white text-sm font-semibold px-5 py-3 rounded-md"
              >
                Avaliação técnica
                <ArrowUpRight className="w-4 h-4" />
              </Link>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
